// Function to get the token and check its expiry
export const getToken = () => {
  const authDataString = localStorage.getItem('authData');

  try {
    const authData = authDataString ? JSON.parse(authDataString) : null;
    if (authData && authData.expiry) {
      return authData.expiry > Date.now() ? authData.token : null;
    }
  } catch (error) {
    console.error('Error parsing token from local storage:', error);
  }
  return null;
};

// Function to get the user and check its expiry
export const getStoredUser = () => {
  const authDataString = localStorage.getItem('authData');
  try {
    const authData = authDataString ? JSON.parse(authDataString) : null;
    if (authData && authData.expiry) {
      return authData.expiry > Date.now() ? authData : null;
    }
  } catch (error) {
    console.error('Error parsing user data from local storage:', error);
  }
  return null;
};
